function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#090909",
  d: "M0 23h258v25H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D8D8D8",
  d: "M0 0h134v28H0z",
  transform: "translate(20 73)",
  opacity: 0.3
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 25,
  x: 20,
  y: 111,
  fill: "#E1E1E1",
  opacity: 0.4,
  rx: 8
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#E1E1E1",
  d: "M65 116h88v5H65zm0 9h48v5H65z",
  opacity: 0.4
});

var SvgCreditCardBackIcon = function SvgCreditCardBackIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 258 160",
    width: 278,
    height: 160,
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 258,
    height: 160,
    x: 0,
    y: 0,
    rx: 6,
    fill: props.color,
    transform: "matrix(-1 0 0 1 258 0)"
  }), _ref2, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Acre-Semibold",
    fontSize: 16,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 160.792,
    y: 93,
    children: props.securitycode
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCardBackIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit_card_back_icon.6a4d6127.svg";
export { ForwardRef as ReactComponent };